import {useEffect, useState} from "react";
const useConfig = () => {
    const [config, setConfig] = useState<any>();
 
    useEffect(() => {

      console.log("Inside Common-hook.tsx");
      
      const loadAsync = async () => {
        const sessionConfig = localStorage.getItem("config");
        if (sessionConfig) {
          setConfig(JSON.parse(sessionConfig));
          return;
        }
 
        const response = await fetch('/appsettings.json').then((res) => {return res;});
        console.log(response)
        const json = await  response.json();
        console.log(json)
        setConfig(json);
        localStorage.setItem("config", JSON.stringify(json));
      };
      loadAsync();
    }, []);
 
    return [config];
  };
 
  export default useConfig;